export default __webpack_public_path__ + "static/media/pre-advise.8fcb87ad.svg";